<template>
    <div class="cont-pub">
        <el-row :gutter="40">
            <el-col :span="11">
                <div class="pobbox">
                    <div class="search-box">
                        <!-- <el-input placeholder="请输入关键词检索" prefix-icon="el-icon-search" v-model="searchName" @change.native="queryPubTree" ></el-input> -->
                        <div class="el-input el-input--mini el-input--prefix">
                            <input type="text" @input="queryPubTree" autocomplete="off" v-model="searchName" class="el-input__inner" placeholder="请输入关键词检索"/>
                            <span class = "el-input__prefix">
                                <i class="el-input__icon el-icon-search"></i>
                            </span>
                        </div>
                    </div>
                    <div class="lefttree" v-if="treeData.length>0">
                        <el-checkbox v-for="(item, i) in treeData" :label="item.gid" v-model="item.ischecked" :key="item.gid" class="check-box" @change="checkboxClick(item, i)" >{{item.orgName}}</el-checkbox>
                    </div>
                    <div v-else class="noData">
                        <img src="../assets/images/nodata.png" alt="暂无数据" />
                        <p>暂无数据</p>
                        <p>请输入{{ typeTxt }}名称查找对应结果！</p>
                    </div>
                </div>
            </el-col>
            <el-col :span="11">
                <div class="pobbox">
                    <p class="tit">已选择
                        <button class="clearbtn" @click="clearDialog" v-if="choosedData.length > 0"><i class="el-icon-delete"></i>清空</button>
                    </p>
                    <ul v-if="choosedData" class="tree right-tree">
                        <li v-for="(item,i) in choosedData" :key="i">
                            <span>{{item.orgName}}</span>
                            <i class="el-icon-circle-close" @click="delSel(item,i)"></i>
                        </li>
                    </ul>
                </div>
            </el-col>
        </el-row>
        <div class="btn_box">
            <span class="btn_canle" @click="closeDialog">取消</span><span class="btn_sure" @click="confirmDialog">确定</span>
        </div>
    </div>
</template>

<script>
import {Input,Row,Col,Loading,CheckboxGroup,Checkbox,Notification} from 'element-ui';
import Message from '../common/utils/message' 
// import { pubList } from '@/api/common'
import Axios from '@/api/diyaxios'
export default {
    props:['msg'],
    data() {
        return {
            flagType:true,
            typeTxt:'出版社',
            typeUrl: '',
            typeParams:{
                enuName:null
            },
            searchName:'',
            treeData:[],
            choosedData:[],
            txt:null,
            pubNames:[]
        }
    },
    components:{
        'el-input':Input,'el-row':Row,'el-col':Col,Loading,'el-checkbox-group':CheckboxGroup,'el-checkbox':Checkbox,Notification
    },
    mounted() {
        let vm = this;
        if(vm.msg){
            if(vm.msg.type == 'lib'){  //类型为“图书馆”
                vm.flagType = false;  // 类型不是出版社
                vm.typeTxt = '图书馆';
                vm.typeUrl = vm.msg.url;
                vm.typeParams = vm.msg.params;
            }else{ // 默认为“出版社”
                console.log(vm.msg,'vm.msg');
                vm.treeData = [];
                // vm.pubNames = vm.msg.pubname,split(',');
                // vm.pubNames.forEach(element => {
                //     vm.treeData.push({'orgName':element});
                //     vm.choosedData.push({'orgName':element});
                // });
               vm.msg.forEach(element => {
                    // vm.treeData.push({'orgName':element.orgName});
                    vm.choosedData.push({'orgName':element});
                    // vm.choosedData.push({'orgName':element.orgName,gid:element.gid});

                });
                vm.treeData.forEach(ele => {
                    vm.$set(ele, 'ischecked', true);
                })
            }
        }
    },
    methods: {
        queryPubTree() {
            let vm = this;
            vm.treeData = []; // 每次查询先清空一下上一次返回的数据
            if(vm.searchName){
                // if(!vm.flagType){
                //     if(vm.msg.type == 'lib') vm.typeParams.orgName = vm.searchName;
                // }else{
                //     vm.typeParams.enuName = vm.searchName;
                // }
                // pubList(vm.typeParams).then(res => {
                // vm.$http.get(vm.typeUrl, {params:vm.typeParams}).then(res => {
                Axios.post('/org/action/page',{
                    params:{
                        pageSize: 50, //最多显示50条
                        orgName:vm.searchName,
                        orgType: 6
                    }
                },{
                    headers:{
                        'Content-Type':'application/json'
                    }
                }).then(res => {
                    let list,
                        result = res.data || [];
                    // if(!vm.flagType){
                    //     if(vm.msg.type == 'lib') list = result; // 图书馆数据
                    // }else{ // 出版社数据
                        list = result.list || [];
                    // }
                    // if(vm.searchName == result.keyValue){
                        list.forEach(element => {
                            element.ischecked = false
                        });
                        let len_right = vm.choosedData.length,
                            len_left = list.length;
                        for(let i = 0;i < len_right; i++){
                            let name_right = vm.choosedData[i].orgName;
                            for(let k=0;k<len_left;k++){
                            let name_left = list[k].orgName;
                                if(name_left == name_right){
                                    list[k].ischecked = true;
                                    break;
                                }
                            }
                        }
                        vm.treeData = list;
                    // }
                }).catch(res => {
                    Notification.error({title:'提示',message:res.msg || '操作失败请稍后再试！',duration:2000});
                })
            }
        },
        checkboxClick(item, i){
            let vm = this,
                len = vm.treeData.length,
                name = item.orgName;
            if(vm.treeData[i].orgName == name){
                vm.$set(vm.treeData[i], 'ischecked', vm.treeData[i].ischecked);
                if(vm.treeData[i].ischecked){
                    vm.choosedData.push(item);
                }else{
                    let len_right = vm.choosedData.length;
                    for(let k = 0;k < len_right;k++){
                        if(vm.choosedData[k].orgName == name){
                            vm.choosedData.splice(k,1);
                            break
                        }
                    }
                }
            }
        },
        delSel(item,i){
            let vm = this,
                len = vm.treeData.length,
                name = item.orgName;
            vm.choosedData.splice(i,1)
            for(let k = 0;k < len; k++){
                if(vm.treeData[k].orgName == name){
                    vm.$set(vm.treeData[k], 'ischecked', false);
                    break
                }
            }
            // vm.pubNames = null;
        },
        clearDialog() {
            let vm = this;
            vm.treeData.forEach(ele => {
                vm.$set(ele, 'ischecked', false);
            });
            vm.choosedData = [];
        },
        closeDialog(e, bool=false, txt=null) {
            let vm = this;
            vm.$emit('close');
        },
        confirmDialog() {
            var vm = this;
            console.log(vm.choosedData,'vm.choosedData11');
            if(!vm.flagType){
                if(vm.choosedData.length > 0){
                    vm.$emit('ok',vm.choosedData);
                }else{
                    Message.info({title:'提示', message:`请选择${vm.typeTxt}！`, type:'warning'});
                }
            }else{  // 出版社
                console.log(vm.choosedData,'vm.choosedData22');
                let dataArr = [];
                let gidArr = [];
                vm.choosedData.forEach(ele => {
                    dataArr.push(ele.orgName)
                    gidArr.push(ele.gid);
                });
                console.log(gidArr,'gidArrgidArr');
                vm.txt = String(dataArr);
                vm.$emit('ok',{pubname:vm.txt,pubid:String(gidArr),choosedData:vm.choosedData});
            }
        }
    }
    
}
</script>

<style lang="scss">
// @import 'src/style/variable';
.cont-pub{
    .el-col .pobbox{
        width: 209px;
        height: 323px;
        padding: 15px;
        padding-right:0px;
        margin:28px 0 0 38px;
        background-color: #fff;
        border-radius: 4px;
        border: solid 1px #c9d7e8;
        .search-box{
            .el-input__inner{
                width: 200px;
                height: 32px;
                padding-left: 28px;
                background-color: #fff;
                border-radius: 16px;
                height: 28px;
                line-height: 28px;
                border: solid 1px #b6d2e6;
            }
            .el-icon-search{
                line-height: 32px;
            }
        }
        .lefttree{
            height: 295px;
            overflow: auto;
            list-style: none;
            .check-box{
                cursor: pointer;
                margin-top:10px;
            }
            /* >li{
                cursor: pointer;
                margin-top:10px;
                .check-box{
                    -webkit-appearance: none;
                    height: 16px;
                    vertical-align: middle;
                    width: 16px;
                    margin-top: -4px;
                    margin-right: 10px;
                    background: url(/images/icon.png) no-repeat -123px -57px;
                }
                .checked-box{
                    background: url(/images/icon.png) no-repeat -93px -83px;
                }
            } */ 
        }
        .tit{
            font-weight: bold;
            margin:4px;
        }
        .right-tree{
            height: 295px;
            overflow: auto;
            list-style: none;
            padding: 0px;
            >li{
                cursor:pointer;
                margin-top:10px;
                span{
                    display: inline-block;
                    width: 170px;
                }
                i{
                    font-size: 17px;
                    color:#bbc8d4;
                }
                &:hover i{
                    color:#1c7bd3;
                }
            }
            >li:hover{
                color: #1c7bd3;
            }

        }
        .noData{
            text-align: center;
            font-size: 12px;
            img{
                height: 90px;
                width: 70px;
                margin: 30px auto 15px;
                display: block;
            }
            .p{
                margin: 4px;
            }
        }
    }
}
.btn_box {
        text-align: center;
        margin-top: 15px;      
    }
    .btn_canle {
            @extend .btnbase;
            color: #2c88f4;
            background-color: #deefff;
        }

        .btn_green {
            @extend .btnbase;
            color: #fff;
            background-color: #67c23a;
        }
     .btn_sure {
         border: 0px;
        font-weight: bold;
        font-size: 12px;
        cursor: pointer;
        display: inline-block;
        height: 33px;
        line-height: 33px;
        margin: 8px 12px;
        width: 70px;
        border-radius: 4px;
            color: #fff;
            background-color: #2c88f4;
        }
         .btnbase {
        border: 0px;
        font-weight: bold;
        font-size: 12px;
        cursor: pointer;
        display: inline-block;
        height: 33px;
        line-height: 33px;
        margin: 8px 12px;
        width: 70px;
        background-color: #deefff;
        border-radius: 4px;
    }
</style>


// WEBPACK FOOTER //
// src/components/pubDialog.vue